<template>
  <div>
    <v-row lass="justify-start ml-2 mr-2">
      <v-col
        cols="12"
        md="6"
        sm="12"
      >
        <v-tooltip
          max-width="500"
          top
        >
          <template v-slot:activator="{ on }">
            <div v-on="on">
              <select-simple-unidade
                :value="unidade"
                :lista-unidades="unidades"
              />
            </div>
          </template>
          <div>Selecione para carregar os dados de outra unidade.</div>
        </v-tooltip>
      </v-col>
      <v-col
        cols="12"
        md="6"
        sm="12"
      >
        <v-tooltip
          bottom
          max-width="500"
          :disabled="usuarios.length === 0"
        >
          <template v-slot:activator="{ on }">
            <div v-on="on">
              <v-autocomplete
                v-model="usuario"
                :disabled="usuarios.length === 0"
                :items="usuarios"
                item-text="nome"
                label="Servidores:"
                placeholder="Digite para pesquisar..."
                prepend-icon="supervisor_account"
                return-object
              />
            </div>
          </template>
          <span>Selecione para carregar os dados referentes a outro servidor</span>
        </v-tooltip>
      </v-col>
    </v-row>
    <v-row v-if="perfilUsuario">
      <v-col>
        <perfil :usuario="perfilUsuario" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Perfil from '@/components/perfil/Perfil';
import SelectSimpleUnidade from '@/components/SelectSimpleUnidade';
import { RepositoryFactory } from '@/repositories/RepositoryFactory';

const usuarioRepository = RepositoryFactory.get('usuario');

export default {
  name: 'RelatorioPerfilServidor',

  components: { Perfil, SelectSimpleUnidade },

  data() {
    return {
      unidade: { selecionado: null },
      usuario: null,
      usuarios: [],
      perfilUsuario: null,
    };
  },

  computed: {
    ...mapState({
      unidades: (state) => state.unidade.unidades,
    }),
  },

  watch: {
    'unidade.selecionado': function (nv) {
      usuarioRepository.getByUnidade(nv.id).then((res) => {
        this.usuarios = res.data;
        this.usuario = null;
        this.perfilUsuario = null;
      });
    },
    usuario(nv) {
      if (nv) {
        usuarioRepository.getByPerfilId(nv.idPerfil).then((res) => (this.perfilUsuario = res.data));
      }
    },
  },
};
</script>
